import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRx from 'vue-rx';
import Vuelidate from 'vuelidate';
import { Observable, Subject, Subscription } from 'rxjs';
import Meta from 'vue-meta';
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import { BootstrapVue, IconsPlugin, TablePlugin } from 'bootstrap-vue'
import axios from 'axios';
import VueMq from 'vue-mq'

import App from './App'
import router from './router'
import config from './cognito-config'

import ToggleButton from 'vue-js-toggle-button'
import vueDebounce from 'vue-debounce';
import filters from './filters/filters';

import vuescroll from "vuescroll/dist/vuescroll-native";
import "vuescroll/dist/vuescroll.css";

import VCalendar from 'v-calendar';

Amplify.configure(config)

Vue.use(BootstrapVue);
Vue.use(TablePlugin);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.use(filters);
Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(Vuelidate);
Vue.use(vuescroll);
Vue.use(VCalendar);
Vue.use(VueRx, {
	Observable,
	Subscription,
	Subject
});
Vue.use(Meta);
Vue.use(ToggleButton);

Vue.use(vueDebounce,{
    listenTo: 'keyup',
    defaultTime: '300ms',
    fireOnEmpty: true
});

Vue.use(VueMq, {
	breakpoints: {
		verysmall: 300,
		small: 450,
		medium: 750,
		large: 1000,
		verylarge: 1200,
		desktop: Infinity
	},
	defaultBreakpoint: 'phone'
})

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

new Vue({
	render: h => h(App),
	router
  }).$mount('#app')
